import { render, staticRenderFns } from "./DetailsNewAnalysis.vue?vue&type=template&id=0e7b2c40"
import script from "./DetailsNewAnalysis.vue?vue&type=script&lang=js"
export * from "./DetailsNewAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports